import { render, staticRenderFns } from "./mpsstatusupdatehistory.vue?vue&type=template&id=a1fed0fc"
import script from "./mpsstatusupdatehistory.vue?vue&type=script&lang=js"
export * from "./mpsstatusupdatehistory.vue?vue&type=script&lang=js"
import style0 from "./mpsstatusupdatehistory.vue?vue&type=style&index=0&id=a1fed0fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports